export default __webpack_public_path__ + "static/test-4bbb9186133024829cb92783f78a2f34.jpg";